import { AllMeetingMessageType } from 'mini-calendar-event-services/lib/schema/AllMeetingMessageType';
import { isMeetingResponse } from './isMeetingResponse';

export const isItemSenderTheMeetingAttendee = (item: AllMeetingMessageType) =>
    isMeetingResponse(item?.ItemClass);
